export default __webpack_public_path__ + "static/media/contact-terms-privacy.6cd7367d.jpg";